
    import Vue from 'vue';
    export default {
      scrollToTop: true,
      head() {
        return {
          title: this.title ,
          meta: [{
              hid: 'og:title',
              property: 'og:title',
              content: this.title
            },
            {
              hid: 'twitter:title',
              property: 'twitter:title',
              content: this.title
            },
            {
            hid: 'description',
            name: 'description',
            content:'Explore the full Name List of "Ram" in both Marathi and English, with an option to switch between the two languages.'
          },
          {
            hid: 'og:description',
            property: 'og:description',
            content:'Explore the full Name List of "Ram" in both Marathi and English, with an option to switch between the two languages.'
           },
          {
            hid: 'twitter:description',
            property: 'twitter:description',
            content: '108 names of Rama, Ram Namavali in Sanskrit, Ram Namavali with meanings, Lord Rama names chanting, Lord Rama'
          },
          {
            hid: 'keywords',
            name: 'keywords',
            content:'108 names of Rama, Ram Namavali in Sanskrit, Ram Namavali with meanings, Lord Rama names chanting, Lord Rama, 108 names of Lord Rama list, राम के नाम, krishna 108 names'
          },
          {
            hid: 'image',
            property: 'image',
            content: this.$config.siteUrl + '/img/namavali/ram.webp'
          },
          {
            hid: 'og:image',
            property: 'og:image',
            content: this.$config.siteUrl + '/img/namavali/ram.webp'
          },
          ],
        }
      },
    
      components: {
      },
      data() {
        return {
          title: 'Ram 108 Namavali | 108 Namavali - राम 108 नामावली(108 नामावली)',
          langauageMarathi: true
        }
      },
      layout: 'detailsPage-withoutFooter',
  
      
      jsonld() {
    return {
      '@context': 'https://schema.org',
      "@graph": [{
        "@type": "Article",
        "mainEntityOfPage": {
          "@type": "WebPage",
          "@id": "https://goa.app/namavali/ram"
        },
        "headline": "Ram 108 Namavali - राम 108 नामावली(108 नामावली)",
        "name" : "Ram 108 Namavali - 108 Namavali",
        "description": "Explore the full Name List of 'Ram' in both Marathi and English, with an option to switch between the two languages.",
        "image": this.$config.siteUrl + '/img/namavali/ram.webp',  
        "author": {
          "@type": "Organization",
          "name": "Goa App",
          "url": "https://goa.app"
        },  
        "publisher": {
          "@type": "Organization",
          "name": "Goa App",
          "logo": {
            "@type": "ImageObject",
            "url": "https://goa.app/android-chrome-384x384.png"
          }
        },
        "datePublished": "2024-10-10T08:00:00+08:00",
        "dateModified": "2024-10-10T09:20:00+08:00"
      },]}
    },
  
      computed: {
  
      },
      methods:{
        changeLanguage:function () {
          this.langauageMarathi = !this.langauageMarathi
        }
      }
  
    }
  